import { render } from "./wellController.vue?vue&type=template&id=65af11c5&scoped=true"
import script from "./wellController.vue?vue&type=script&lang=js"
export * from "./wellController.vue?vue&type=script&lang=js"

import "./wellController.vue?vue&type=style&index=0&id=65af11c5&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65af11c5"]])

export default __exports__